import { useState, useEffect } from 'react'

function useWindowWidth() {
  const isWindowClient = typeof window === 'object'

  const [windowWidth, setWindowWidth] = useState(
    isWindowClient ? window.innerWidth : undefined
  )

  useEffect(() => {
    const setSize = () => setWindowWidth(window.innerWidth)

    if (isWindowClient) {
      window.addEventListener('resize', setSize)

      return () => window.removeEventListener('resize', setSize)
    }
  }, [isWindowClient, setWindowWidth])

  return windowWidth
}

export default useWindowWidth
